import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNopermission = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={36} height={36} fill='none' {...props}>
    <path
      stroke='#F23645'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M9 15h4.5M10.14 33h15.72c4.14 0 5.79-2.535 5.985-5.625l.78-12.39a5.6 5.6 0 0 0-1.11-3.72M27 9a2.47 2.47 0 0 1-2.175-1.335l-1.08-2.175c-.69-1.365-2.49-2.49-4.02-2.49H16.29c-1.545 0-3.345 1.125-4.035 2.49l-1.08 2.175A2.47 2.47 0 0 1 9 9c-3.255 0-5.835 2.745-5.625 5.985l.78 12.39c.075 1.23.39 2.385 1.005 3.315'
    />
    <path
      stroke='#F23645'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M15 25.965A4.88 4.88 0 0 0 18 27a4.884 4.884 0 0 0 4.875-4.875c0-.96-.27-1.845-.75-2.595M33 3 3 33'
    />
  </svg>
);
export default SvgNopermission;
